import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'Courier New', Courier, monospace;
  font-weight: 600;

  &:nth-child(odd) {
    background-color: #222;
  }
`;

export const Timestamp = styled.div`
  width: 130px;
  color: pink;
`;

export const Message = styled.div`
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 550px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  span {
    color: goldenrod;
    width: 60px;
    text-align: right;
    display: inline-block;
  }
`;

export const Data = styled.div`
  color: dodgerblue;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 20px;
`;

export const DataPreview = styled.div`
  color: cyan;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
